export const CUSTOM_POI_LOGO_LAYER = 'customPoiLogoLayer'
export const POI_LOGO_LAYER = 'poiLogoLayer'
export const CLUSTER_ASSETS = 'clusterAssetsLayer'
export const ASSETS = 'assetsLayer'
export const EXCLUDED_ASSETS = 'excludedAssetsLayer'
export const EXCLUDED_CLUSTER_ASSETS = 'excludedClusterAssetsLayer'
export const HIGHLIGHTED_ASSETS = 'highlightedAssetsLayer'
export const POI_LAYER = 'poiLayer'
export const AUDIENCES_QUINTILE_TILESET_LAYER = 'audiencesQuintileTilesetLayer'
export const ISOCHRONES_LAYER = 'isochronesLayer'
export const CUSTOM_POI_LAYER = 'customPoiLayer'
export const BOUNDARIES_LAYER = 'boundariesLayer'
export const ASSETS_IDS_LAYER = 'assetsIdsLayer'
export const GEOCODER_LAYER = 'geocoderLayer'
export const EDITABLE_LAYER = 'editableLayer'
export const EDITABLE_DATA_LAYER = 'editableDataLayer'
export const HEATMAP_ASSETS_LAYER = 'HeatmapAssetsLayer'

export const L2_COLORS = [
  '#1f77b4',
  '#aec7e8',
  '#ff7f0e',
  '#ffbb78',
  '#2ca02c',
  '#98df8a',
  '#d62728',
  '#ff9896',
  '#9467bd',
  '#c5b0d5',
  '#8c564b',
  '#c49c94',
  '#e377c2',
  '#f7b6d2',
  '#7f7f7f',
  // '#c7c7c7', - Color for excluded assets
  '#bcbd22',
  '#dbdb8d',
  '#17becf',
  '#9edae5',
]

export const AllLayersPrecedence = [
  // POI logo layers render above every other map element (sc-563940):
  // custom-POI logos cover standard-POI logos purely by z-order.
  CUSTOM_POI_LOGO_LAYER,
  POI_LOGO_LAYER,
  HIGHLIGHTED_ASSETS,
  ASSETS,
  CLUSTER_ASSETS,
  EXCLUDED_CLUSTER_ASSETS,
  EXCLUDED_ASSETS,
  POI_LAYER,
  CUSTOM_POI_LAYER,
  AUDIENCES_QUINTILE_TILESET_LAYER,
  GEOCODER_LAYER,
  ISOCHRONES_LAYER,
  EDITABLE_DATA_LAYER,
  HEATMAP_ASSETS_LAYER,
  BOUNDARIES_LAYER,
]
